// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingStatusBadge-moduleRentalPortalListingStatusBadge__JVMQK";
export { _1 as "RentalPortalListingStatusBadge" }
